<template>
  <modal
    title="Ajouter une commande"
    class="custom-modal"
    v-model="modalOpened"
    @ok="handleNewOrder()"
    @cancel="$emit('close')"
    effect="fade/zoom"
    cancelText="Fermer"
    okText="Enregistrer"
    :backdrop="false"
    large
  >
    <div slot="modal-header" class="modal-header row m-0">
      <h4 class="modal-title col-4">Ajouter une commande B2C</h4>

      <div class="pt-1">
        <div class="pull-right">
          <div class="form-group d-inline-block mr-1">
            <span class="mr-1"><i class="fa fa-cutlery"></i> Nutrition</span>

            <label
              class="switch switch-sm switch-text switch-info float-right mb-0 mr-0"
            >
              <input
                type="checkbox"
                class="switch-input"
                v-model="form.isNutrition"
                :disabled="!hasPermission($store.state.user, 'ORDERS_WRITE')"
                @change="changeIsNutrition"
              />
              <span class="switch-label" data-on="On" data-off="Off"></span>

              <span class="switch-handle"></span>
            </label>
          </div>

          <div class="form-group d-inline-block mr-1">
            <span class="mr-1"><i class="fa fa-video-camera"></i> Visio</span>

            <label
              class="switch switch-sm switch-text switch-info float-right mb-0 mr-0"
            >
              <input
                type="checkbox"
                class="switch-input"
                v-model="form.hasVisio"
                @change="changeHasVisio"
                :disabled="!hasPermission($store.state.user, 'ORDERS_WRITE')"
              />
              <span class="switch-label" data-on="On" data-off="Off"></span>

              <span class="switch-handle"></span>
            </label>
          </div>

          <div class="form-group d-inline-block mr-1">
            <span class="mr-1"><i class="fa fa-gift"></i> Carte cadeau</span>

            <label
              class="switch switch-sm switch-text switch-info float-right mb-0 mr-0"
            >
              <input
                type="checkbox"
                class="switch-input"
                v-model="form.giftCard.isGiftCard"
                @change="handleChangeIsGiftCard()"
                :disabled="!hasPermission($store.state.user, 'ORDERS_WRITE')"
              />

              <span class="switch-label" data-on="On" data-off="Off"></span>

              <span class="switch-handle"></span>
            </label>
          </div>

          <div class="form-group d-inline-block" v-if="!form.isCredit">
            <span class="mr-1"><i class="icon-envelope"></i> Email</span>

            <label
              class="switch switch-sm switch-text switch-info float-right mb-0 mr-0"
            >
              <input
                type="checkbox"
                class="switch-input"
                v-model="form.sendEmail"
                :disabled="!hasPermission($store.state.user, 'ORDERS_WRITE')"
              />
              <span class="switch-label" data-on="On" data-off="Off"></span>

              <span class="switch-handle"></span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex">
      <div class="col-sm-6">
        <div class="row">
          <div class="form-group col" v-if="form.hasVisio">
            <label>Type de prestations (visio) *</label>

            <v-select
              v-model="form.visio.prestationType"
              :options="visioPrestationsType"
              :class="this.formErrors.visioPrestationType ? 'has-error' : ''"
            ></v-select>
          </div>
        </div>

        <div class="row">
          <div class="form-group col" v-if="form.hasVisio">
            <label>Durée de la visio (en minutes)</label>

            <v-select
              v-model="form.visio.visioDuration"
              :options="visioDurations"
            ></v-select>
          </div>
        </div>

        <div class="row">
          <div class="form-group has-danger col">
            <label>Commercial</label>
            <v-select
              :options="commercials"
              v-model="form.commercial"
              :class="this.formErrors.commercial ? 'has-error' : ''"
            ></v-select>
          </div>
        </div>

        <div class="row">
          <div class="form-group has-danger col">
            <label>Société *</label>

            <v-select
              v-model="form.merchantId"
              :options="merchantsOptions"
              :class="this.formErrors.merchantId ? 'has-error' : ''"
              @click.native="checkIfEmpty"
              @input="handleMerchantChange"
            ></v-select>
          </div>
        </div>

        <div class="row">
          <div class="form-group has-danger col">
            <label>Concept *</label>

            <v-select
              v-model="form.concept"
              :options="conceptsOptions"
              :class="this.formErrors.concept ? 'has-error' : ''"
              @input="updatePaymentMethods()"
            >
              <span slot="no-options"
                >Sélectionnez une option pour Société.</span
              >
            </v-select>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-sm-6">
            <label>Prix *</label>

            <div
              class="input-group"
              :class="this.formErrors.price ? 'has-error' : ''"
            >
              <input
                v-model="form.price"
                type="text"
                class="form-control"
                :disabled="allSessionsAreFree"
                @input="(e) => formPriceInput(e.target.value)"
              />

              <span class="input-group-addon"><i class="fa fa-euro"></i></span>
            </div>

            <small class="text-danger" v-if="form.isCredit">
              Avoir de <strong>{{ form.price }}&euro;</strong>, une facture sera
              générée directement.
            </small>
          </div>

          <div
            v-if="!isFreeOrder && !allSessionsAreFree && !form.isCredit"
            class="form-group col-sm-6"
          >
            <div class="form-group">
              <label> Paiement CB </label>

              <div class="input-group" style="padding-top: 7px">
                <label
                  class="switch switch-sm switch-text switch-info float-right mb-0 mr-0"
                >
                  <input
                    type="checkbox"
                    class="switch-input"
                    v-model="form.paymentData.isCB"
                    :disabled="
                      !hasPermission($store.state.user, 'ORDERS_WRITE') ||
                      form.paymentData.isAI
                    "
                    @change="createSubPayments"
                  />
                  <span class="switch-label" data-on="On" data-off="Off"></span>

                  <span class="switch-handle"></span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!form.isCredit && !isFreeOrder && !allSessionsAreFree">
          <div class="row">
            <!-- Description paiement (si CB) -->
            <div class="form-group col" v-if="form.paymentData.isCB">
              <label style="width: 100%">
                Description Paiement

                <a class="pull-right" href="#" @click="createSubPayments">
                  <i class="fa fa-refresh"></i>
                </a>
              </label>

              <input
                v-model="form.paymentData.description"
                type="text"
                class="form-control"
              />
            </div>

            <!-- Choix du mode de paiement (par défaut) -->
            <div class="form-group col" v-else>
              <div class="form-group" style="position: relative">
                <label style="width: 100%">
                  Choix du mode de paiement (par défaut)

                  <a class="pull-right" href="#" @click="createSubPayments">
                    <i class="fa fa-refresh"></i>
                  </a>
                </label>

                <div class="input-group">
                  <span class="input-group-addon">Paiement par</span>

                  <select
                    v-model="form.paymentData.type"
                    @change="createSubPayments"
                    :disabled="form.paymentData.isAI"
                    class="form-control"
                  >
                    <option
                      :key="key"
                      v-for="(pm, key) in paymentMethods"
                      :value="pm.name"
                    >
                      {{ pm.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-sm-3">
              <label>
                Avance imm.
                <i
                  class="fa fa-info-circle"
                  v-tooltip="
                    `Avance immédiate : ${
                      !client.urssafInscription
                        ? 'client non inscrit'
                        : 'ne peut contenir de paiement CB & doit être dans COMP'
                    }`
                  "
                ></i>
              </label>
              <div class="input-group" style="padding-top: 7px">
                <label
                  class="switch switch-sm switch-text switch-info float-right mb-0 mr-0"
                >
                  <input
                    type="checkbox"
                    class="switch-input"
                    v-model="form.paymentData.isAI"
                    :disabled="
                      !hasPermission($store.state.user, 'ORDERS_WRITE') ||
                      !client.urssafInscription ||
                      !client.urssafInscription.valid ||
                      !isMerchantCompanyOrder
                    "
                    @change="toggleAI"
                  />
                  <span class="switch-label" data-on="On" data-off="Off"></span>
                  <span class="switch-handle"></span>
                </label>
              </div>
            </div>

            <div class="form-group col-sm-4">
              <label> Nombre d'échéances </label>

              <div class="input-group">
                <input
                  v-model="form.paymentData.countPayments"
                  type="number"
                  min="1"
                  max="20"
                  class="form-control"
                  @input="createSubPayments"
                />
              </div>
            </div>

            <div class="form-group col-sm-5">
              <label style="width: 100%">
                Première échéance

                <a class="pull-right" href="#" @click="createSubPayments">
                  <i class="fa fa-refresh"></i>
                </a>
              </label>

              <datepicker
                v-model="form.paymentData.wishedDay"
                format="dd.MM.yyyy"
                language="fr"
                input-class="form-control"
              ></datepicker>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <template>
                <div class="row">
                  <div class="col">
                    <div
                      class="alert alert-info"
                      v-if="form.paymentData.sessionPrice"
                    >
                      <strong>Information</strong> Prix d'une séance
                      {{ form.paymentData.sessionPrice }} €
                    </div>
                  </div>
                </div>

                <div
                  class="alert alert-danger"
                  v-if="sessionsDifference || paymentsDifference"
                >
                  Veuillez ajuster les séances de :
                  {{ sessionsDifference }} séance{{
                    sessionsDifference > 1 ? "s" : ""
                  }}
                  pour {{ paymentsDifference }} €
                </div>

                <div class="alert alert-danger" v-if="formErrors.missingType">
                  Veuillez ajouter une description (si CB) ou un mode (si pas
                  CB) aux paiements.
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="row">
          <div class="form-group col-sm-7">
            <label>Pack</label>

            <v-select
              v-model="form.session"
              :options="sessions"
              :class="this.formErrors.session ? 'has-error' : ''"
              @input="(e) => createSubPayments(e)"
            ></v-select>
          </div>

          <div class="col-sm-5">
            <div class="form-group">
              Séances offertes
              <label
                class="switch switch-sm switch-text switch-info float-right mb-0 mr-0"
              >
                <input
                  type="checkbox"
                  class="switch-input"
                  v-model="form.freeSessions.enabled"
                  :disabled="!hasPermission($store.state.user, 'ORDERS_WRITE')"
                  @change="toggleEnableFreeSessions"
                />

                <span class="switch-label" data-on="On" data-off="Off"></span>

                <span class="switch-handle"></span>
              </label>
            </div>

            <div v-if="form.freeSessions.enabled" class="form-group">
              <label>Nombre de séances offertes</label>

              <v-select
                v-model="form.freeSessions.quantity"
                :options="availableSessions"
                :class="this.formErrors.freeSessions ? 'has-error' : ''"
                @input="(e) => createSubPayments(e)"
              ></v-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-sm-6">
            <label>
              Description

              <span v-if="form.giftCard.isGiftCard">carte cadeau</span>

              <span v-else>commande</span>

              (visible facturation)
            </label>

            <textarea
              v-model="client.billing.description"
              type="text"
              class="form-control"
            />
          </div>

          <div class="form-group col-sm-6">
            <label>
              Label de la

              <span v-if="form.giftCard.isGiftCard">carte cadeau</span>

              <span v-else>commande</span>

              (visible coach)
            </label>

            <textarea v-model="form.label" type="text" class="form-control" />
          </div>
        </div>

        <div class="row">
          <div class="form-group col">
            <label>Menu / Statistique *</label>
            <v-select
              v-model="form.menuStat"
              :options="menuStatsOptions"
              label="label"
              :selectable="(option) => !option.disable"
              :class="this.formErrors.menu ? 'has-error' : ''"
              :disabled="form.isCredit"
            />
          </div>
        </div>

        <div class="row">
          <div class="form-group col-sm-7">
            Valeurs par défaut des sessions
            <label
              class="switch switch-sm switch-text switch-info float-right mb-0 mr-0"
            >
              <input
                type="checkbox"
                class="switch-input"
                v-model="form.editSessions"
                @input="fetchClientCoachs"
                :disabled="!hasPermission($store.state.user, 'ORDERS_WRITE')"
              />
              <span class="switch-label" data-on="On" data-off="Off"></span>
              <span class="switch-handle"></span>
            </label>
          </div>
        </div>

        <div v-if="form.editSessions" class="row">
          <div class="form-group col-sm-8">
            <label>Coach</label>

            <v-select
              v-model="form.defaultCoach"
              :options="coachs"
              @search="searchCoachs"
              :class="this.formErrors.coach ? 'has-error' : ''"
            ></v-select>
          </div>

          <div class="form-group col-sm-4">
            <label>Crédit/séance</label>

            <input
              type="text"
              class="form-control"
              v-model="form.defaultCredit"
            />
          </div>
        </div>

        <div class="row" v-if="form.giftCard.isGiftCard">
          <div class="form-group col-sm-6">
            <label>Expéditeur</label>
            <input
              v-model="form.giftCard.sender"
              type="text"
              class="form-control"
            />
          </div>

          <div class="form-group col-sm-6">
            <label>Destinataire</label>

            <input
              v-model="form.giftCard.recipient"
              type="text"
              class="form-control"
            />
          </div>

          <div class="form-group col">
            <label>Message carte cadeau</label>

            <textarea
              v-model="form.giftCard.message"
              type="text"
              class="form-control"
              maxlength="80"
            />
            <p>
              <strong class="text-muted">
                {{ giftCardMaxChar }} caractères restants.
              </strong>
            </p>
          </div>
        </div>
      </div>
    </div>

    <el-table :data="form.payments" v-if="!form.paymentData.isAI">
      <el-table-column label="Prix" width="100">
        <template slot-scope="scope"> {{ scope.row.price }} € </template>
      </el-table-column>
      <el-table-column label="CB" align="center" width="40">
        <template slot-scope="scope">
          <input
            class="form-control"
            type="checkbox"
            v-model="scope.row.isCB"
            @input="clearPaymentType(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="Description" width="200">
        <template slot-scope="scope">
          <input
            class="form-control"
            type="text"
            v-model="scope.row.type"
            :disabled="!scope.row.isCB"
          />
        </template>
      </el-table-column>
      <el-table-column label="Date de prélèvement" width="170">
        <template slot-scope="scope">
          <el-date-picker
            v-model="scope.row.deadline"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            type="date"
          />
        </template>
      </el-table-column>
      <el-table-column label="Mode">
        <template slot-scope="scope">
          <select
            v-if="!scope.row.isCB"
            v-model="scope.row.type"
            class="form-control"
          >
            <option
              :key="key"
              v-for="(pm, key) in paymentMethods"
              :value="pm.name"
            >
              {{ pm.name }}
            </option>
          </select>
        </template>
      </el-table-column>

      <el-table-column label="Séances" width="125">
        <template slot-scope="scope">
          <input
            v-model="scope.row.nbSessions"
            type="number"
            class="form-control"
            @input="(e) => formPaymentAiSessionInput(e.target.value, scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>

    <el-table :data="form.payments" v-else>
      <el-table-column label="Prix">
        <template slot-scope="scope"> {{ scope.row.price }} € </template>
      </el-table-column>
      <el-table-column label="Date de prélèvement">
        <template slot-scope="scope">
          <el-date-picker
            v-model="scope.row.deadline"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            type="date"
          />
        </template>
      </el-table-column>
      <el-table-column label="Séances">
        <template slot-scope="scope">
          <input
            v-model="scope.row.nbSessions"
            type="number"
            class="form-control"
            @input="(e) => formPaymentAiSessionInput(e.target.value, scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import Modal from "vue-strap/src/Modal";
import debounce from "lodash.debounce";
import moment from "moment";

export default {
  components: {
    Modal,
    Datepicker,
  },

  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
    clientData: {
      type: Object,
      required: true,
    },
    merchantsData: {
      type: Array,
      required: true,
    },
    conceptsData: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      coachs: [],
      client: null,
      commercials: [],
      conceptsOptions: [],
      form: {
        commercial: null,
        concept: null,
        defaultCoach: null,
        defaultCredit: "30",
        description: null,
        freeSessions: {
          enabled: false,
          quantity: null,
        },
        giftCard: {
          isGiftCard: false,
          message: "",
          recipient: "",
          sender: "",
        },
        hasVisio: false,
        isCredit: null,
        label: null,
        menuStat: null,
        merchantId: null,
        isNutrition: false,
        payments: [],
        paymentData: {
          countPayments: 1,
          description: null,
          isAI: false,
          isCB: true,
          sessionPrice: null,
          type: null,
          wishedDay: moment().add("15", "days").format(),
        },
        price: null,
        sendEmail: true,
        session: null,
        visio: {
          prestationType: null,
          visioDuration: null,
        },
      },
      formErrors: {
        commercial: false,
        coach: false,
        concept: false,
        freeSessions: false,
        giftCard: false,
        menuStat: false,
        merchantId: false,
        missingType: false,
        price: false,
        session: false,
        visioPrestationType: false,
      },
      formSending: false,
      modalOpened: false,
      paymentMethods: [],
      sessions: [],
      visioDurations: [
        { label: "30", value: 30 },
        { label: "45", value: 45 },
        { label: "60", value: 60 },
        { label: "75", value: 75 },
        { label: "90", value: 90 },
        { label: "105", value: 105 },
        { label: "120", value: 120 },
      ],
      visioPrestationsType: [],
    };
  },

  computed: {
    ...mapGetters({
      orderStatus: "getOrderStatusGroups",
      orderStatusFollowed: "getOrderStatusFollowedGroups",
      menuStatsOptions: "getMenuStatsOptions",
    }),

    merchantsOptions() {
      return this.merchantsData.map((m) => ({
        label: m.name,
        value: m.id,
      }));
    },

    availableSessions() {
      return this.form.session?.value
        ? this.sessions.slice(0, this.form.session.value)
        : [];
    },

    allSessionsAreFree() {
      return (
        this.form.freeSessions.enabled &&
        this.form.session?.value &&
        this.form.freeSessions.quantity?.value &&
        parseInt(this.form.freeSessions.quantity.value) >=
          parseInt(this.form.session.value)
      );
    },

    isFreeOrder() {
      return this.form.price && parseFloat(this.form.price) === 0;
    },

    paymentsDifference() {
      let diff = 0;

      if (this.form.payments) {
        let totalsPayments = 0;

        for (const p of this.form.payments) {
          totalsPayments += +p.price;
        }

        diff = this.form.price - totalsPayments;
      }

      return diff.toFixed(2) === "0.00" || diff.toFixed(2) === "-0.00"
        ? 0
        : diff.toFixed(2);
    },

    sessionsDifference() {
      let diff = 0;

      if (
        this.form.payments &&
        this.form.payments.length > 0 &&
        this.form.session?.value
      ) {
        const totalSessionsToPay =
          this.form.freeSessions.enabled &&
          this.form.freeSessions.quantity?.value
            ? parseInt(this.form.session.value) -
              parseInt(this.form.freeSessions.quantity.value)
            : parseInt(this.form.session.value);
        let totalPaymentsNbSessions = 0;

        for (const p of this.form.payments) {
          totalPaymentsNbSessions += +p.nbSessions;
        }

        diff = totalSessionsToPay - totalPaymentsNbSessions;
      }

      return diff;
    },

    giftCardMaxChar() {
      return 80 - this.form.giftCard.message.length;
    },

    addOrderBlocked() {
      return (
        this.unpaidQuantity >= 1 &&
        this.conceptIsAffectedByOrderBlocking &&
        !this.hasPermission(
          this.$store.state.user,
          "BLOCKED_IMPAYED_ORDERS_READ",
        )
      );
    },

    isMerchantCompanyOrder() {
      return (
        this.form.merchantId?.value === this.$store.state.merchantIds.company
      );
    },

    merchantCompany() {
      return this.merchantsData.find(
        (m) => m.id === this.$store.state.merchantIds.company,
      );
    },

    merchantCorporate() {
      return this.merchantsData.find(
        (m) => m.id === this.$store.state.merchantIds.corporate,
      );
    },

    conceptJustCoaching() {
      return this.conceptsData.find((c) => c.name === "justcoaching.fr");
    },

    conceptNutrition() {
      return this.conceptsData.find((c) => c.name === "Nutrition");
    },

    cleanedCredit() {
      return (
        parseFloat(this.form.defaultCredit.replace(",", ".")).toFixed(2) * 100
      );
    },
  },

  watch: {
    isShow(newVal) {
      this.modalOpened = newVal;
    },

    clientData: {
      handler(val) {
        this.client = val;
      },

      deep: true,
    },
  },

  created() {
    this.modalOpened = this.isShow;
    this.client = this.clientData;

    this.loadB2CCommercials();
    this.defaultSelectionInputs();

    for (let i = 1; i <= 200; i++) {
      this.sessions.push({
        label: this.formatPack(i.toString()),
        value: i.toString(),
      });

      if (!this.form.session) {
        this.form.session = this.sessions[0];
      }
    }
  },

  methods: {
    async loadB2CCommercials() {
      try {
        const { data: b2cCommercials } = await this.$api.get(
          "/users/commercials/search",
          {
            params: { b2c: true },
          },
        );

        this.commercials = b2cCommercials.map((c) => ({
          label: c.commercial.pseudo,
          value: c.email,
        }));

        this.setDefaultCommercial();
      } catch (e) {
        this.commercials = [];
      }
    },

    setDefaultCommercial() {
      if (this.commercials.length > 0) {
        if (this.$store.state.user?.commercial?.isB2C) {
          const currentUserCommercial = this.commercials.find(
            (c) => c.value === this.$store.state.user.email,
          );

          if (currentUserCommercial) {
            this.form.commercial = currentUserCommercial;
            return;
          }
        }

        if (this.client?.commercials?.length > 0) {
          const sortedCommercials = this.client.commercials.sort(
            (a, b) => new Date(b.relatedSince) - new Date(a.relatedSince),
          );

          const mostRecentCommercial = sortedCommercials[0];
          const commercialOption = this.commercials.find(
            (c) => c.value === mostRecentCommercial.user,
          );

          if (commercialOption) {
            this.form.commercial = commercialOption;
          }
        }
      }
    },

    defaultSelectionInputs() {
      this.form.merchantId = {
        label: this.merchantCompany?.name,
        value: this.merchantCompany?.id,
      };
      this.form.concept = this.conceptJustCoaching?.name;

      this.handleMerchantChange(this.form.merchantId);
      this.updatePaymentMethods();

      if (this.client.orders.filter((o) => o.discovery).length === 1) {
        this.form.menuStat = this.menuStatsOptions.find(
          (m) => m.value === "pack-conversion",
        );
      }

      if (this.client.orders.length > 1) {
        this.form.menuStat = this.menuStatsOptions.find(
          (m) => m.value === "pack-fidelisation",
        );
      }
    },

    async changeHasVisio() {
      if (!this.form.hasVisio) {
        this.form.visio.prestationType = null;
        this.form.isNutrition = false;

        this.defaultSelectionInputs();
      } else if (this.form.hasVisio) {
        if (this.visioPrestationsType.length === 0) {
          this.fetchVisioPrestationsType();
        }

        this.form.paymentData.isAI = false;
        this.form.concept = this.conceptJustCoaching?.name;
        this.form.merchantId = {
          label: this.merchantCorporate?.name,
          value: this.merchantCorporate?.id,
        };
        this.handleMerchantChange(this.form.merchantId);
      }
    },

    async changeIsNutrition() {
      if (this.form.isNutrition) {
        this.form.hasVisio = true;
        this.form.paymentData.isAI = false;
        this.form.concept = this.conceptNutrition?.name;
        this.form.merchantId = {
          label: this.merchantCorporate?.name,
          value: this.merchantCorporate?.id,
        };

        if (this.visioPrestationsType.length === 0) {
          this.fetchVisioPrestationsType();
        }

        this.handleMerchantChange(this.form.merchantId);
      } else if (!this.form.isNutrition && this.form.hasVisio) {
        this.form.isNutrition = false;
        this.form.concept = this.conceptJustCoaching?.name;
      } else {
        this.defaultSelectionInputs();
      }
    },

    async fetchVisioPrestationsType() {
      const { data } = await this.$api.get("/visio/prestations-type");
      this.visioPrestationsType = data?.map((prestation) => {
        return { label: prestation.label, value: prestation.uuid };
      });
    },

    handleMerchantChange(merchant) {
      const DISABLED_FROM_CREATION = [
        "Just Coaching Live",
        "Just Coaching Live Solo",
      ];

      if (
        this.form.hasVisio &&
        merchant?.value === this.$store.state.merchantIds.company
      ) {
        this.form.hasVisio = false;
      }

      if (
        this.form.isNutrition &&
        merchant?.value === this.$store.state.merchantIds.company
      ) {
        this.form.isNutrition = false;
      }

      if (merchant?.value === this.$store.state.merchantIds.corporate) {
        this.form.paymentData.isAI = false;
      }

      this.conceptsOptions = [];

      if (merchant?.value) {
        this.conceptsOptions = this.conceptsData
          .filter((c) =>
            c.merchants?.some((m) => m.merchantId === merchant.value),
          )
          .filter((c) => {
            if (!DISABLED_FROM_CREATION.includes(c.name)) {
              return c.name;
            }
          })
          .map(({ name }) => name);
      }

      if (
        this.form.concept &&
        !this.conceptsOptions.includes(this.form.concept)
      ) {
        this.form.concept = null;
      }
    },

    handleChangeIsGiftCard() {
      if (this.form.giftCard && this.form.giftCard.isGiftCard) {
        this.form.menuStat = {
          label:
            "Pack OneShot/Event (Menu Conversion - Fidélisation / Stat Acquisition)",
          value: "one-shot",
          disable: false,
        };

        this.form.description = "Carte cadeau";
      }
    },

    checkIfEmpty() {
      if (!this.form.merchantId) {
        this.conceptsOptions = [];
        this.form.concept = null;
      }
    },

    async updatePaymentMethods() {
      if (!this.form.concept) {
        this.paymentMethods = [];

        return;
      }

      if (this.form.isNutrition && this.form.concept !== "Nutrition") {
        this.form.isNutrition = false;
      }

      if (this.form.hasVisio && this.form.concept !== "justcoaching.fr") {
        this.form.hasVisio = false;
        this.form.visio.prestationType = null;
      }

      try {
        const { data } = await this.$api.get("/payment-methods/by-concept", {
          params: { concept: this.form.concept },
        });

        this.paymentMethods = data;
      } catch (e) {
        console.log(e);
      }
    },

    createSubPayments(e) {
      if (e && typeof e.preventDefault === "function") e.preventDefault();

      if (
        !this.form.session?.value ||
        !this.form.price ||
        parseFloat(this.form.price) <= 0
      ) {
        this.form.payments = [];
        this.form.paymentData.sessionPrice = null;
        return;
      }

      if (
        this.form.freeSessions.enabled &&
        this.form.freeSessions.quantity?.value &&
        parseInt(this.form.freeSessions.quantity.value) >=
          parseInt(this.form.session.value)
      ) {
        this.form.payments = [];
        this.form.paymentData.sessionPrice = null;
        return;
      }

      if (!this.form.isCredit && this.form.price) {
        const payments = [];

        const nbOfSessions =
          this.form.freeSessions.enabled &&
          this.form.freeSessions.quantity?.value
            ? parseInt(this.form.session.value) -
              parseInt(this.form.freeSessions.quantity.value)
            : parseInt(this.form.session.value);
        const globalPrice = parseFloat(this.form.price);
        const nbPaiement = parseInt(this.form.paymentData.countPayments);

        const sessionPrice = globalPrice / nbOfSessions;
        const quotient = Math.floor(nbOfSessions / nbPaiement);
        const remainder = nbOfSessions % nbPaiement;

        let type = this.form.paymentData.type;
        let deadline = moment(this.form.paymentData.wishedDay).format();

        if (this.form.paymentData.isCB) {
          type = this.form.paymentData.description;
        } else if (this.form.paymentData.isAI) {
          type = "Avance immédiate";
        }

        for (let index = 0; index < nbPaiement; index++) {
          let total = sessionPrice * quotient;
          let countSession = quotient;

          if (index < remainder) {
            total = (quotient + 1) * sessionPrice;
            countSession = quotient + 1;
          }

          payments.push({
            price: total.toFixed(2),
            captured: false,
            type,
            alert: true,
            alertMessage: "",
            deadline,
            isCB: this.form.paymentData.isCB,
            isAI: this.form.paymentData.isAI,
            nbSessions: countSession,
          });

          deadline = moment(deadline).add(1, "M").format();

          this.form.paymentData.sessionPrice = sessionPrice;

          this.form.payments = payments;
        }
      }
    },

    toggleEnableFreeSessions() {
      if (!this.form.freeSessions.enabled) {
        this.form.freeSessions.quantity = null;
      }

      this.createSubPayments();
    },

    formPriceInput(value) {
      this.form.price = this.formatFormPrice(value);

      this.createSubPayments();
    },

    async fetchClientCoachs() {
      if (this.form.client) {
        try {
          const { data } = await this.$api.get(
            `/clients/coachs/${this.form.client.value}`,
          );

          this.coachs = data;
        } catch (e) {
          console.log(e);
        }
      }
    },

    fetchCoachs: debounce(async (search, loading, vm) => {
      if (!search || search.lentgh < 3) {
        return;
      }

      loading(true);

      const { data } = await vm.$api.post("/users/coachs/search", {
        query: search,
        filterBy: ["firstName", "lastName", "email"],
      });

      vm.coachs = data.map((c) => ({
        label: `${c.coach ? c.coach.name : ""} (${c.email})`,
        value: c.email,
        id: c.id,
      }));

      loading(false);

      return vm.clients;
    }, 300),

    async searchCoachs(search, loading) {
      if (search !== "") {
        await this.fetchCoachs(search, loading, this);
      }
    },

    checkFields() {
      this.formErrors.client = !this.form.client;

      if (this.addOrderBlocked) {
        this.formErrors.client = true;
      }

      this.formErrors.commercial = !this.form.commercial?.value;
      this.formErrors.session = !this.form.isCredit && !this.form.session;
      this.formErrors.concept = !this.form.concept;
      this.formErrors.menuStat = !this.form.menuStat;
      this.formErrors.merchantId = !this.form.merchantId;
      this.formErrors.price =
        !this.form.price ||
        (this.form.freeSessions.enabled &&
          this.form.freeSessions.quantity?.value &&
          this.form.session?.value &&
          parseInt(this.form.freeSessions.quantity.value) >=
            parseInt(this.form.session.value) &&
          parseFloat(this.form.price) > 0);

      if (
        !this.form.isCredit &&
        this.form.payments &&
        this.form.payments.length > 0
      ) {
        if (this.form.payments.find((p) => !p.type)) {
          this.formErrors.missingType = true;
        } else {
          this.formErrors.missingType = false;
        }

        this.formErrors.paymentsDifference = !!this.paymentsDifference;
      } else {
        this.formErrors.missingType = false;
        this.formErrors.paymentsDifference = false;
      }

      if (this.form.hasVisio && !this.form.visio.prestationType) {
        this.formErrors.visioPrestationType = true;
      } else {
        this.formErrors.visioPrestationType = false;
      }

      this.formErrors.freeSessions =
        this.form.freeSessions.enabled &&
        (!this.form.freeSessions.quantity?.value ||
          !this.form.session?.value ||
          parseInt(this.form.freeSessions.quantity.value) >
            parseInt(this.form.session.value) ||
          (parseInt(this.form.freeSessions.quantity.value) >=
            parseInt(this.form.session.value) &&
            this.form.price &&
            parseFloat(this.form.price) > 0));

      return (
        Object.values(this.formErrors).filter((error) => error).length === 0
      );
    },

    toggleAI() {
      if (this.form.paymentData.isAI) {
        this.form.paymentData.isCB = false;
      }

      if (this.form.hasVisio) {
        this.form.hasVisio = false;
        this.defaultSelectionInputs();
      }

      if (this.form.isNutrition) {
        this.form.isNutrition = false;
        this.defaultSelectionInputs();
      }

      this.createSubPayments();
    },

    async sendEmailAfterCreation(order) {
      await this.$api.post(`/orders/send-creation-email/${order.id}`);
    },

    async handleNewOrder() {
      this.form.client = this.client.email;
      this.form.description =
        "Facturation de " +
        this.form.session.label +
        (this.client.billing?.description
          ? "\n\n" + this.client.billing.description
          : "");

      const commercial = this.form.commercial?.value;

      if (!this.checkFields() || this.formSending) {
        this.$errorToast("Les champs entourés en rouge sont obligatoires");
        return;
      }

      const isConversion =
        this.form.menuStat &&
        this.form.menuStat.value &&
        (this.form.menuStat.value === "decouverte" ||
          this.form.menuStat.value === "one-shot");

      const isAcquisition =
        this.form.menuStat &&
        this.form.menuStat.value &&
        (this.form.menuStat.value === "decouverte" ||
          this.form.menuStat.value === "pack-conversion" ||
          this.form.menuStat.value === "one-shot" ||
          this.form.menuStat.value === "autres");

      const isFidelisation =
        this.form.menuStat &&
        this.form.menuStat.value &&
        (this.form.menuStat.value === "pack-conversion" ||
          this.form.menuStat.value === "pack-fidelisation" ||
          this.form.menuStat.value === "one-shot");

      let defaultCoach;
      let defaultCredit;

      if (this.form.editSessions) {
        defaultCoach = this.form.defaultCoach && this.form.defaultCoach.value;
        defaultCredit = this.cleanedCredit;
      }

      try {
        this.$emit("orderLoading", true);
        this.formSending = true;

        const { data } = await this.$api.post("/orders", {
          client: this.form.client,
          commercial,
          concept: this.form.concept,
          defaultCoach,
          defaultCredit,
          description: this.form.description,
          freeSessions:
            this.form.freeSessions.enabled &&
            this.form.freeSessions.quantity?.value
              ? this.form.freeSessions.quantity.value
              : 0,
          giftCard: this.form.giftCard,
          hasVisio: this.form.hasVisio,
          isAcquisition,
          isAI: this.form.paymentData.isAI,
          isConversion,
          isCredit: this.form.isCredit,
          isFidelisation,
          isNutrition: this.form.isNutrition,
          isOneShotEvent: this.form.menuStat?.value === "one-shot",
          label: this.form.label,
          labelDescription: this.client.billing.label,
          merchantId: this.form.merchantId.value,
          payments: this.form.payments,
          price: this.form.price.replace(",", "."),
          session: this.form.session.value,
          visioDuration:
            this.form.visio.visioDuration &&
            this.form.visio.visioDuration.value,
          visioPrestationType:
            this.form.visio.prestationType &&
            this.form.visio.prestationType.value,
        });

        this.newOrder = false;

        if (!this.form.isCredit && this.form.sendEmail) {
          this.$confirm({
            message: "Envoyez un email pour informer le client ?",
            onConfirm: async () => {
              await this.sendEmailAfterCreation(data);
            },
          });
        }

        this.$emit("success", data);
        this.$emit("close");
      } catch (err) {
        this.formSending = false;

        this.$errorToast(
          err.response?.data?.message ||
            "Une erreur est survenue lors de la création de la commande.",
        );
      } finally {
        this.$emit("orderLoading", false);
      }
    },
  },
};
</script>
